<template>
    <div>
        <Card>
            <template #title>
                Usuários
            </template>
            <template #content>
                <Toolbar class="mb-2 bg-gray-100">
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-plus" label="Incluir" severity="info" size="small"
                                @click="openForm({ ativo: 1 })" />
                            <Button icon="pi pi-search" label="Buscar" severity="success" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="nome" header="Nome" sortable></Column>
                    <Column field="login" header="Login" sortable></Column>
                    <Column field="email" header="E-mail" sortable></Column>
                    <Column field="perfil" header="Perfil" sortable></Column>
                    <Column style="width: 180px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <i v-if="data.ativo" class="pi pi-circle-fill text-green-400 flex align-items-center" v-tooltip.top="'Ativo'"></i>
                            <i v-else class="pi pi-circle-fill text-red-400 flex align-items-center" v-tooltip.top="'Inativo'"></i>
                            <Button icon="pi pi-lock" title="Senha" size="small"
                                @click="openFormSenha(data)" />
                            <Button icon="pi pi-building" title="Acessos" size="small"
                                :aria-label="`Acessos de ${data.nome}`"
                                @click="openFormAcesso(data)" />
                            <Button icon="pi pi-pen-to-square" title="Atualizar" class="p-button-rounded p-button-text p-button-info p-0 w-2rem h-2rem"
                                @click="openForm(data)" />
                            <Button icon="pi pi-trash" title="Remover" class="p-button-rounded p-button-text p-button-danger p-0 w-2rem h-2rem"
                                @click="remove(data)" />
                        </template>
                    </Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>
        <UsuarioForm :visible="visibleForm" :data="item" @close="closeForm" @save="loadData" />
        <UsuarioFormSenha :visible="visibleFormSenha" :usuario="item" @close="closeFormSenha" @save="loadData" />
        <UsuarioFormAcesso :visible="visibleFormAcesso" :usuario="item" @close="closeFormAcesso" @save="loadData" />
        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="nome" v-model="params.filter.nome" class="w-full" />
                                <label for="nome">Nome</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="login" v-model="params.filter.login" class="w-full" />
                                <label for="login">Login</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="email" v-model="params.filter.email" class="w-full" />
                                <label for="email">E-mail</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <Select id="ativo" v-model="params.filter.ativo" :options="statusOptions"
                                    optionLabel="label" optionValue="value" :showClear="true" class="w-full" />
                                <label for="ativo">Status</label>
                            </FloatLabel>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>

        </Popover>
    </div>
</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';

import Usuario from '@/service/usuario.js';
import UsuarioForm from '@/page/usuario/Form.vue';
import UsuarioFormSenha from '@/page/usuario/FormSenha.vue';
import UsuarioFormAcesso from '@/page/usuario/FormAcesso.vue';

import Filter from '@/utils/Filter.js';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        Select,

        /* Form */
        UsuarioForm,
        UsuarioFormSenha,
        UsuarioFormAcesso,
    },
    data() {
        return {
            lista: [],
            isLoading: false,
            item: {},
            visibleForm: false,
            visibleFormSenha: false,
            visibleFormAcesso: false,

            params: {
                filter: {},
                sort: {
                    field: 'u.id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
            statusOptions: [
                { label: 'Ativos', value: 1 },
                { label: 'Inativos', value: 0 }
            ]
        }
    },
    beforeMount() {
        this.pagination.page = parseInt(this.$route.query.page || 0);
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadData();
    },
    methods: {        
        openFormSenha(item) {
            this.item = { ...item };
            this.visibleFormSenha = true;
        },
        closeFormSenha(event) {
            this.item = {};
            this.visibleFormSenha = false;
        },
        openFormAcesso(item) {
            this.item = { ...item };
            this.visibleFormAcesso = true;
        },
        closeFormAcesso(event) {
            this.item = {};
            this.visibleFormAcesso = false;
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Usuario.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Usuario.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
